"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationProvider = void 0;
var tslib_1 = require("tslib");
var react_oidc_context_1 = require("@axa-fr/react-oidc-context");
var casl_1 = require("@readcloud/casl");
var jsonwebtoken_1 = tslib_1.__importDefault(require("jsonwebtoken"));
var react_1 = tslib_1.__importStar(require("react"));
var context_1 = require("../../context");
var AuthorizationProvider = function (_a) {
    var children = _a.children;
    var oidcUser = (0, react_oidc_context_1.useReactOidc)().oidcUser;
    var decodedToken = (0, react_1.useMemo)(function () {
        var _a;
        if (oidcUser) {
            var token = jsonwebtoken_1.default.decode(oidcUser.access_token);
            var userScopes = ((_a = token.userScope) === null || _a === void 0 ? void 0 : _a.split(' ')) || [];
            return tslib_1.__assign(tslib_1.__assign({}, token), { userScopes: userScopes });
        }
        return null;
    }, [oidcUser]);
    var ability = (0, react_1.useMemo)(function () {
        if (decodedToken) {
            return (0, casl_1.defineRules)(decodedToken.role, decodedToken.userScopes);
        }
        return null;
    }, [decodedToken]);
    return (react_1.default.createElement(context_1.TokenContext.Provider, { value: decodedToken },
        react_1.default.createElement(context_1.AbilityContext.Provider, { value: ability }, children)));
};
exports.AuthorizationProvider = AuthorizationProvider;
//# sourceMappingURL=index.js.map